import { Box, Divider, Link } from '@mui/material';
import React, { PropsWithChildren, useEffect } from 'react';
import { ReactComponent as Logo } from 'src/assets/empowergpt-logo.svg';
import LinkedInLogo from 'src/assets/LinkedInLogo.png';
import { ReactComponent as WorldIcon } from 'src/assets/world.svg';
import { LanguageDropdown } from './Signup/LanguageDropdown';
import { useLanguage } from './Signup/LanguageDropdown/useLanguage';

const KCThemeTemplate: React.FC<
  PropsWithChildren<{
    header: React.ReactNode;
    showFooter: Boolean;
    setRenderErrors;
  }>
> = ({ header, showFooter, children, setRenderErrors }) => {
  const { language } = useLanguage();

  useEffect(() => {
    setRenderErrors(true);
  }, [language]);

  return (
    <React.Fragment>
      <Box className="tw:w-full  tw:flex tw:justify-between tw:items-center tw:px-4 tw:py-2 sm:tw:px-6 md:tw:px-8">
        <Logo width="170px" height="40px" />
        <LanguageDropdown />
      </Box>
      <Box className="tw:flex tw:justify-center tw:items-center tw:w-full tw:min-h-[calc(100vh-60px)] tw:bg-transparent">
        <Box
          sx={{
            width: '100%',
            maxWidth: '848px',
            padding: {
              xs: '16px 16px ',
              sm: '32px 32px ',
              md: '80px 184px 80px 184px'
            }
          }}
          className="tw:rounded-xl tw:bg-[#ffffff]"
        >
          <Box className="tw:block tw:flex-col tw:items-center tw:justify-center tw:w-full">
            <Box className="tw:font-['Lato'] tw:text-center tw:flex tw:flex-col tw:items-center tw:justify-center tw:w-full">
              {header}
            </Box>
            {children}
            {showFooter && (
              <Box
                width={'160px'}
                className="tw:flex tw:items-center tw:xs:16px tw:sm:24px"
              >
                <Link
                  href="https://www.linkedin.com/company/empowergpt/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw:w-auto tw:h-[32px] sm:tw:h-[24px]"
                >
                  <img
                    src={LinkedInLogo}
                    style={{
                      width: 'inherit',
                      height: 'inherit'
                    }}
                  />
                </Link>

                <Divider orientation="vertical" sx={{ marginX: '16px' }} />

                <Link
                  href="https://empowergpt.ai/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    width: {
                      xs: '32px',
                      sm: '24px'
                    },
                    height: {
                      xs: '32px',
                      sm: '24px'
                    }
                  }}
                >
                  <WorldIcon width="100%" height="100%" />
                </Link>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default KCThemeTemplate;
